import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import ChevronUpIcon from '@/assets/icons/heroIcons/Chevron-down.svg';
import { mergeClasses } from '@/utils/style';
interface Props {
  title: string;
  className?: string;
  isInitiallyOpen?: boolean;
}
export function CollapsibleSection(props) {
  const $ = _c(24);
  const {
    title,
    children,
    className,
    isInitiallyOpen
  } = props;
  const [isOpen, setIsOpen] = useState(isInitiallyOpen || false);
  let t0;
  if ($[0] !== isOpen) {
    t0 = () => {
      setIsOpen(!isOpen);
    };
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleAccordion = t0;
  let t1;
  if ($[2] !== title) {
    t1 = <span className="font-semibold">{title}</span>;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isOpen && "rotate-180 transform";
  let t3;
  if ($[4] !== t2) {
    t3 = mergeClasses("text-light-gray-500 h-4 w-4 transition-transform", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <ChevronUpIcon className={t3} aria-hidden="true" />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isOpen || $[9] !== t1 || $[10] !== t4 || $[11] !== toggleAccordion) {
    t5 = <button type="button" className="flex w-full items-center justify-between py-4 text-left" onClick={toggleAccordion} aria-expanded={isOpen}>{t1}{t4}</button>;
    $[8] = isOpen;
    $[9] = t1;
    $[10] = t4;
    $[11] = toggleAccordion;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = isOpen ? "open" : "collapsed";
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      open: {
        opacity: 1,
        height: "auto",
        maxHeight: 380
      },
      collapsed: {
        opacity: 0,
        height: 0,
        maxHeight: 0
      }
    };
    t8 = {
      duration: 0.15
    };
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[15] !== children) {
    t9 = <div className="pb-4">{children}</div>;
    $[15] = children;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <AnimatePresence><motion.div initial="collapsed" animate={t6} exit="collapsed" variants={t7} transition={t8} className="overflow-auto">{t9}</motion.div></AnimatePresence>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== className || $[21] !== t10 || $[22] !== t5) {
    t11 = <div className={className}>{t5}{t10}</div>;
    $[20] = className;
    $[21] = t10;
    $[22] = t5;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}